import { _ as __read } from '../../../../tslib.es6-fe064bda.js';
import React__default, { useState, useCallback, useEffect } from 'react';

var OverlayFooter = function (_a) {
    var title = _a.title, activeOverlay = _a.activeOverlay, children = _a.children;
    var _b = __read(useState(null), 2), isOpen = _b[0], setIsOpen = _b[1];
    var handleToggle = useCallback(function () {
        setIsOpen(function (prev) { return !prev; });
    }, [setIsOpen]);
    useEffect(function () {
        setIsOpen(null);
    }, [activeOverlay]);
    return (React__default.createElement("div", { className: "pgc-limits-payouts-results-bottom ".concat(isOpen ? 'show-last-cards' : isOpen === false ? 'hide-last-cards' : '') },
        React__default.createElement("div", { className: "pgc-limits-payouts-results-bottom-inner-wr" },
            React__default.createElement("div", { className: "pgc-limits-payouts-results-bottom-inner-wr-top" },
                React__default.createElement("div", { className: "pgc-last-card-shower", onClick: handleToggle },
                    React__default.createElement("p", { className: "pgc-last-card-shower-txt" }, title),
                    React__default.createElement("div", { className: "pgc-last-card-shower-icon-block" },
                        React__default.createElement("i", { className: "icon-arrow-down" })))),
            React__default.createElement("div", { className: "pgc-limits-payouts-results-bottom-inner-wr-bottom" }, children))));
};

export { OverlayFooter };
